import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import vuescroll from 'vuescroll';
import FetchCommonData from './plugins/FetchCommonData/v2'
Vue.use(FetchCommonData)
Vue.use(vuescroll);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
